module.exports = __webpack_public_path__ + "img/step4.07f83f33.png";